<template>
  <div class="slider-arrows">
    <button type="button" title="Влево" class="slider-arrows__item" :disabled="swiper && swiper.isBeginning" @click="$emit('left')">
      <IconComponent name="arrow-left-1" />
    </button>
    <button type="button" title="Вправо" class="slider-arrows__item" :disabled="swiper && swiper.isEnd" @click="$emit('right')">
      <IconComponent name="arrow-right-1" />
    </button>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";

export default {
  name: "SliderArrowsComponent",
  props: {
    swiper: Object,
  },
  components: { IconComponent },
};
</script>

<style lang="stylus">
.slider-arrows {
  z-index: 1;
  display flex
  justify-content: center
  gap 15px
  margin-top: 30px

  &__item {
    z-index: 1;
    background: transparent
    box-sizing: border-box;
    border-radius: 50%
    width 40px
    height 40px
    display flex
    align-items center
    justify-content center
    cursor pointer
    margin auto 0
    background var(--main-color-75)
    border: 1px solid var(--main-color-75);
    transition var(--transition)

    &:not([disabled]) {
      &:hover {
        background transparent
        border 1px solid var(--main-color)

        .icon svg path {
          stroke var(--main-color)
        }
      }
    }

    &[disabled] {
      cursor: default
      border: 1px solid var(--gray);
      background transparent

      .icon svg path {
        stroke var(--main-color)
      }
    }

    .icon {
      width 16px
      height 16px
      +below(840px) {
        width 10px
        height 10px
      }

      svg path {
        stroke var(--white)
        transition var(--transition)
      }
    }
  }
}
</style>
